// @flow

import * as React from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import ManyToOneForm from '../../../../../Components/ManyToOneForm';
import Labor from '../../../../../Model/Labor';
import FormCol from '../../../../../Components/FormCol';
import AnalyseLabor from '../../../../../Model/AnalyseLabor';
import LaborUebermittlung from '../../../../../Model/LaborUebermittlung';
import LaborAbteilung from '../../../../../Model/LaborAbteilung';

type Props = {
  labor: AnalyseLabor,
  index: number,
  onRemove: (index: number) => void,
};

@observer
export default class AnalyseLaborForm extends React.Component<Props, void> {
  render() {
    const { labor: analyseLabor, labor: { labor } } = this.props;
    const { id: laborId } = labor || {};

    return (
      <Card style={{ marginBottom: 16 }}>
        <CardBody>
          <Row>
            <FormCol>
              <ManyToOneForm entity={analyseLabor} type={Labor} field={'labor'} title={'Labor'} />
            </FormCol>
            {laborId ? (
              <FormCol>
                <ManyToOneForm
                  entity={analyseLabor}
                  type={LaborAbteilung}
                  field={'abteilung'}
                  title={'Abteilung'}
                />
              </FormCol>
            ) : null}
            {laborId ? (
              <FormCol>
                <ManyToOneForm
                  entity={analyseLabor}
                  type={LaborUebermittlung}
                  field={'uebermittlung'}
                  title={'Übermittlung'}
                />
              </FormCol>
            ) : null}
          </Row>
        </CardBody>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Views/Analysis/View/AnalyseForm/LaborTab/AnalyseLaborForm.js